module.exports = __webpack_public_path__ + "files/b01eeacb89ae99c4e56f518d0b439a97.png";